module.exports = "/_next/static/images/881bdfef63a30d77b3c6334fe8c9c087-women-xs.png.webp";